import React, { useState, useContext } from "react";
import {
  Button,
  Card,
  Form,
  Container,
  Col,
  Row
} from "react-bootstrap";

import AuthNavbar from "../components/Navbars/AuthNavbar";
import GuestNavbar from "../components/Navbars/private/GuestNavbar";
// import companyLogoURL from "../../assets/img/baolinPrivate/logo-baolin-header-removebg-preview.png";
import LogoURL from "../assets/img/baolinPrivate/logo-baolin-header-removebg-preview.png"
import { GuestContext } from "../contexts/GuestContext";
import AuthFooter from "components/Footers/AuthFooter";

function Guest({ children }) {
  const { language, pageBanner, toggleLanguage } = useContext(GuestContext);
  // const banner1 = language === "Chinese" ? "阿彌陀佛" : "Amituofo";
  const banner2 = language === "Chinese" ? "寶林禪寺法會報名" : "Bao Lin Event Registration";
  const lanuageToggleElement = (<>
    <Row >
      <Col md={{ span: 10, offset: 1 }} className="d-flex justify-content-center align-items-center">
        <div className="d-flex align-items-center justify-content-center mb-2">
          <label className="mb-0">
            <span className={`mr-2 mb-0 ${language === 'Chinese' ? "text-white" : "text-white-50"}`}>
              中文
            </span>
          </label>
          <Form.Check
            type="switch"
            id="language"
            checked={language === 'English'}
            onChange={toggleLanguage}
          />
          <label className="mb-0">
            <span className={`ml-2 ${language === 'English' ? "text-white" : "text-white-50"}`}>
              English
            </span>
          </label>
        </div>
      </Col>
    </Row>
  </>)

  return (
    <>
      <div className="wrapper wrapper-full-page">
        <GuestNavbar />
        <div
          className="full-page lock-page"
          data-color="black"
          data-image={require("../assets/img/full-screen-image-2.jpg")}
        >
          <div className="content d-flex align-items-center p-0">
            <Container>
              <div className="mx-auto mt-5">
                <Row >
                  <Col xs={12} className="text-center mb-2 d-none d-md-block">
                    <img src={LogoURL} alt="Bao Lin Logo" width="200" className="mr-4" />
                  </Col>

                  <Col xs={12} className="text-center mb-4 ">
                    <h2 style={{ color: 'white' }}>
                      {pageBanner == 1 ? null : banner2}
                    </h2>
                  </Col>
                </Row>
                {pageBanner == 1 ? null : lanuageToggleElement}

                {children}
              </div>
            </Container>
          </div>

          <div
            className="full-page-background"
            style={{
              backgroundImage: `linear-gradient(to right, rgba(180, 227, 145, 0.5), rgba(150, 201, 61, 0.5)), url(${require("../assets/img/baolinPrivate/buddha.avif")})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat"
            }}
          ></div>
        </div>
          {/* <AuthFooter /> */}
      </div>
    </>
  );
}

export default Guest;
